import  { useState, useEffect,} from "react";
import Grid from "@mui/material/Grid2";
import { IconButton } from "@mui/material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ClearIcon from '@mui/icons-material/Clear';
import { imgurl } from "../../Utils/Baseurl";

const FilePreviewGrid = ({ files,update }) => {
  const [fileURLs, setFileURLs] = useState([]);
  console.log(fileURLs,"urllfilee");
  

  // Generate object URLs once
  useEffect(() => {
    const urls = files.map(file => ({
      file,
      url: update ? `${imgurl}/${file.file}` :URL.createObjectURL(file),
    }));

    setFileURLs(urls);

    return () => {
      // Revoke URLs on cleanup
      urls.forEach(({ url }) => URL.revokeObjectURL(url));
    };
  }, [files]);

  return (
    <Grid size={{ xs: 12, md: 12, lg: 12 }} container spacing={1}>
        
      {

        
        
        update? fileURLs.map(({ file, url }, index) => {
     console.log(url,"urldata");
      const isImage = file?.materialType!="PDF";
        const isPDF = file?.materialType=="PDF";
        console.log(file.materialType,"mattype");

        console.log(isPDF,"isimage");
        
        
        return (
          <Grid size={{ xs: 4, md: 4, lg: 4 }} >
            <a
  href={url}
//   download={file.name}
  style={{ textDecoration: "none" }}
>
  <IconButton sx={{ display: "flex", justifyContent: "space-between", width: "90%",color:"blue" }}>
   <ClearIcon sx={{color:"red"}} />
    <CloudDownloadIcon />
  </IconButton>


</a>


            {isImage && (
              <img
                src={url}
                // alt={file}
              
              />
            )}

            {isPDF && (
              <iframe
                 src={url}
                //  title={"TAMILPRIYAN"}
              
              />
            )}


          </Grid>
        );
      }):
      fileURLs.map(({ file, url }, index) => {
        const isImage = file.type.startsWith("image/");
        const isPDF = file.type === "application/pdf";
     console.log(url,"udata");
     
        return (
          <Grid size={{ xs: 4, md: 4, lg: 4 }} >
            <a
  href={url}
  download={file.name}
  style={{ textDecoration: "none" }}
>
  <IconButton sx={{ display: "flex", justifyContent: "space-between", width: "90%",color:"blue" }}>
   <ClearIcon sx={{color:"red"}} />
    <CloudDownloadIcon />
  </IconButton>


</a>


            {isImage && (
              <img
                src={url}
                alt={file.name}
              
              />
            )}

            {isPDF && (
              <iframe
                src={url}
                // title={file.name}
              
              />
            )}


          </Grid>
        );
      })
      
      }
    
    </Grid>
  );
};
export default FilePreviewGrid